import { render, staticRenderFns } from "./SchoolStickerPrint.vue?vue&type=template&id=9e2d8b9a&scoped=true"
import script from "./SchoolStickerPrint.vue?vue&type=script&lang=js"
export * from "./SchoolStickerPrint.vue?vue&type=script&lang=js"
import style0 from "./SchoolStickerPrint.vue?vue&type=style&index=0&id=9e2d8b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2d8b9a",
  null
  
)

export default component.exports